/* global axios */
import ApiClient from './ApiClient';

class CrmConfigAPI extends ApiClient {
  constructor() {
    super('crm_config', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.patch(this.url, data);
  }

  backup() {
    return axios.get(`${this.url}/backup`);
  }

  restore(data) {
    return axios.post(`${this.url}/restore`, data);
  }
}

export default new CrmConfigAPI();
